import { selectAccessControlFormViewModel } from "@/features/management-settings/forms/access-control-form.view-model";
import type { SubjectDto, SubjectDtoType } from "@/spz-api/model";
import { Button } from "@spz/ui/components/button";
import { Form, FormField } from "@spz/ui/components/form";
import { SearchableSelect } from "@spz/ui/components/searchable-select";
import type { Ref } from "react";
import { useTranslation } from "react-i18next";

interface AccessControlFormProps {
  subjectId: SubjectDto["id"];
  subjectType: SubjectDtoType;
  ref?: Ref<HTMLFormElement>;
}
export const AccessControlForm = ({
  subjectId,
  subjectType,
  ref,
}: AccessControlFormProps) => {
  const { t } = useTranslation();

  const { form, onSubmit, companies, roles, isLoading } =
    selectAccessControlFormViewModel({
      subjectId,
      subjectType,
    });

  return (
    <Form {...form}>
      <form
        ref={ref}
        onSubmit={onSubmit}
        id="access-control-form"
        className="flex flex-col gap-4"
      >
        <FormField
          control={form.control}
          name="role"
          render={({ field, fieldState }) => (
            <SearchableSelect
              {...field}
              placeholder={t("role")}
              className="w-full"
              options={roles.options}
              error={fieldState.error}
              onSelect={(ids: string[]) => {
                const id = ids[0];
                field.onChange(id);
                field.onBlur();
              }}
              value={field.value ? [field.value] : []}
            />
          )}
        />

        <FormField
          control={form.control}
          name="company"
          render={({ field, fieldState }) => (
            <SearchableSelect
              {...field}
              placeholder={t("company")}
              className="w-full"
              sections={companies.sections}
              error={fieldState.error}
              onSelect={(ids: string[]) => {
                const id = ids[0];
                field.onChange(id);
                field.onBlur();
              }}
              value={field.value ? [field.value] : []}
            />
          )}
        />

        <div className="flex justify-between items-center gap-2 w-full">
          <Button type="submit" disabled={isLoading}>
            {t("add")}
          </Button>
        </div>
      </form>
    </Form>
  );
};
